const photography = `# My Photography

## Colombia - Spring 2020

![Colombia 1](/images/my-photography/colombia/cali1.jpg)
![Colombia 2](/images/my-photography/colombia/cali2.jpg)
![Colombia 3](/images/my-photography/colombia/cali3.jpg)
![Colombia 4](/images/my-photography/colombia/cali4.jpg)
![Colombia 5](/images/my-photography/colombia/cali5.jpg)
![Colombia 6](/images/my-photography/colombia/cali6.jpg)
![Colombia 7](/images/my-photography/colombia/cali7.jpg)
![Colombia 8](/images/my-photography/colombia/cali8.jpg)
![Colombia 9](/images/my-photography/colombia/cali9.jpg)
![Colombia 10](/images/my-photography/colombia/cali10.jpg)

---

## Hong Kong - Summer 2019

![Hong Kong 1](/images/my-photography/hk/hk1.jpg)
![Hong Kong 2](/images/my-photography/hk/hk2.jpg)
![Hong Kong 3](/images/my-photography/hk/hk3.jpg)
![Hong Kong 4](/images/my-photography/hk/hk4.jpg)
![Hong Kong 5](/images/my-photography/hk/hk5.jpg)
![Hong Kong 6](/images/my-photography/hk/hk6.jpg)
![Hong Kong 7](/images/my-photography/hk/hk7.jpg)
![Hong Kong 8](/images/my-photography/hk/hk8.jpg)
![Hong Kong 9](/images/my-photography/hk/hk9.jpg)
![Hong Kong 10](/images/my-photography/hk/hk10.jpg)

`;

export default photography;
